var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#DA3451"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 41H14.5469V31.4688H18.1328V29.9609H9.27344V31.4688H12.8672V41ZM23.8672 41.1484C26.7266 41.1484 28.0078 39.4297 28.0078 36.6719V29.9609H26.3281V36.5469C26.3281 38.4531 25.7266 39.5234 23.8672 39.5234C22.0156 39.5234 21.4219 38.4609 21.4219 36.5625V29.9609H19.7422V36.75C19.7422 39.4375 21.0078 41.1484 23.8672 41.1484ZM37.4453 29.9609V38.2109L32.5156 29.9609H30.8281V41H32.4453V32.7188L37.3594 41H39.0547V29.9609H37.4453ZM46.5938 41.1484C48.1562 41.1484 49.375 40.4453 50.0078 39.3047L50.1562 41H51.4922V35.125H47.2812V36.4844H49.8359L49.7969 36.7734C49.6641 38.6484 48.4141 39.6406 46.5938 39.6406C44.0938 39.6406 43.0312 37.75 43.0312 35.4062C43.0312 33.125 44.1484 31.2656 46.5938 31.2656C48.1172 31.2656 49.2812 31.9688 49.8203 33.5312L51.3125 32.9062C50.4453 30.875 48.7812 29.7969 46.6094 29.7969C43.0547 29.7969 41.3672 32.3672 41.3672 35.4766C41.3672 38.5781 43.0781 41.1484 46.5938 41.1484ZM52.8359 41H54.6719L55.5859 38.5156H60.0234L60.9219 41H62.7344L58.4375 29.9609H57.1484L52.8359 41ZM56.1094 37.0703L57.8047 32.4062L59.4922 37.0703H56.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a249720172f2c69cddd7500c428db11f.svg";
export { ForwardRef as ReactComponent };